module.exports = __webpack_public_path__ + "img/cb-fullscreen-exit.d3ffcbfb.svg";